var map = {
	"./ProjectLogo.png": 97212,
	"./about-us.jpg": 97444,
	"./about-us_mobile.jpg": 27247,
	"./about-us_pad.jpg": 9398,
	"./activity-arrow-grey.svg": 77527,
	"./activity-arrow.svg": 67865,
	"./activity-trace.png": 12007,
	"./activity-ufo.png": 60020,
	"./alien-left-arm.svg": 20462,
	"./alien-right-arm.svg": 50275,
	"./alien-smiles.svg": 15563,
	"./alien-two.svg": 74394,
	"./alien.svg": 31643,
	"./animation-coin.gif": 24343,
	"./approved-kyc-icon.svg": 38447,
	"./arrow-left.svg": 48609,
	"./arrow-right.svg": 22188,
	"./arrow-up.svg": 92601,
	"./banner-wrapper.svg": 21762,
	"./banner-wrapper_mobile.svg": 11367,
	"./banner-wrapper_pad.svg": 252,
	"./banner.jpg": 76358,
	"./bg-pixel.svg": 72736,
	"./body-bg.svg": 82182,
	"./brief.svg": 6102,
	"./brief_mobile.svg": 90699,
	"./brief_pad.svg": 90320,
	"./clouds-rocket.png": 34413,
	"./clouds.svg": 40044,
	"./coin.svg": 14793,
	"./completed-projects-bottom-image.svg": 9088,
	"./completed-projects-upper-image.svg": 24215,
	"./countdown-right-border.svg": 14585,
	"./dummy-active-logo.png": 98955,
	"./dummy-partner-logo.svg": 94089,
	"./dummy-slide.png": 92442,
	"./feature-bg.png": 16646,
	"./features-image.jpg": 19353,
	"./features-image_mobile.jpg": 5128,
	"./features-image_pad.jpg": 48575,
	"./figure-top.svg": 49464,
	"./figure.svg": 71642,
	"./fonts/BaiJamjuree-Medium.ttf": 34765,
	"./fonts/PressStart2P-Regular.ttf": 59708,
	"./fonts/SpaceMono-Bold.ttf": 88372,
	"./fonts/SpaceMono-BoldItalic.ttf": 96447,
	"./fonts/SpaceMono-Italic.ttf": 27838,
	"./fonts/SpaceMono-Regular.ttf": 76430,
	"./footer-img_mobile.svg": 4446,
	"./footer-mount-img.svg": 78037,
	"./footer-top-img-main.svg": 7483,
	"./footer-top-img-main_mobile.svg": 56460,
	"./footer-top-img-main_pad.svg": 82409,
	"./footer-top-img.svg": 3259,
	"./footer-top-img_mobile.svg": 78988,
	"./footer-top-img_pad.svg": 12553,
	"./golden-chest.svg": 13265,
	"./icons/BNB.svg": 14287,
	"./icons/ETH.svg": 33728,
	"./icons/angle-bottom.svg": 18460,
	"./icons/angle-left.svg": 87654,
	"./icons/angle-right.svg": 46693,
	"./icons/back.svg": 79082,
	"./icons/burn-icon.svg": 42230,
	"./icons/calender.svg": 26973,
	"./icons/copy-icon.svg": 29098,
	"./icons/dolphin.svg": 86177,
	"./icons/filter.svg": 87985,
	"./icons/home-arrow-right.svg": 63115,
	"./icons/instagram.svg": 85373,
	"./icons/interest-filled-white.svg": 84682,
	"./icons/interest-filled.svg": 29342,
	"./icons/interest-pts.svg": 3449,
	"./icons/interest-white.svg": 46041,
	"./icons/interest.svg": 43749,
	"./icons/like-filled-white.svg": 75051,
	"./icons/like-filled.svg": 73883,
	"./icons/like-white.svg": 17402,
	"./icons/like.svg": 45998,
	"./icons/m-footer.svg": 50784,
	"./icons/mail.svg": 59814,
	"./icons/medium.svg": 83926,
	"./icons/menu.svg": 72434,
	"./icons/net/BNB Smart Chain.svg": 73987,
	"./icons/net/Cosmos.svg": 57523,
	"./icons/net/Ethereum.svg": 4124,
	"./icons/net/Harmony.svg": 85159,
	"./icons/net/Kusama.svg": 28473,
	"./icons/net/Minima.svg": 5152,
	"./icons/net/Moonriver.svg": 77450,
	"./icons/net/Near.svg": 63129,
	"./icons/net/Polygon.svg": 86047,
	"./icons/net/Solana.svg": 51759,
	"./icons/post.svg": 3249,
	"./icons/prawn.svg": 62981,
	"./icons/question.svg": 64515,
	"./icons/save-icon.svg": 1894,
	"./icons/search.svg": 64343,
	"./icons/share.svg": 67300,
	"./icons/shark.svg": 26850,
	"./icons/stake-icon.svg": 747,
	"./icons/telegram-footer.svg": 93846,
	"./icons/telegram.svg": 50830,
	"./icons/time.svg": 97592,
	"./icons/twitter.svg": 18592,
	"./icons/user.svg": 10698,
	"./icons/users.svg": 73557,
	"./icons/wallet.svg": 56736,
	"./icons/whale.svg": 64350,
	"./innovation-logo.svg": 51665,
	"./investments_behind_table_bg.svg": 90912,
	"./investments_behind_table_bg_mobile.svg": 23405,
	"./investments_behind_table_bg_pad.svg": 47262,
	"./join-innovation-back.jpeg": 82385,
	"./like-filled.svg": 20924,
	"./like.svg": 74243,
	"./logo-a.gif": 42328,
	"./logo-a.svg": 6905,
	"./logo.svg": 63935,
	"./menu-icons/active.svg": 66295,
	"./menu-icons/completed.svg": 73468,
	"./menu-icons/disconnect.svg": 43571,
	"./menu-icons/innovation.svg": 74816,
	"./menu-icons/my-investment.svg": 34475,
	"./menu-icons/otc.svg": 32883,
	"./menu-icons/private.svg": 35514,
	"./menu-icons/referral-program.svg": 46613,
	"./menu-icons/settings.svg": 21850,
	"./menu-icons/stake.svg": 14129,
	"./menu-icons/wallet.svg": 79074,
	"./meteors-body-left.svg": 95220,
	"./meteors-body-right.svg": 30235,
	"./meteors-body.svg": 47242,
	"./meteors-mobile.svg": 58684,
	"./meteors.svg": 85345,
	"./moon-big.webp": 44627,
	"./moon.png": 22783,
	"./moon.svg": 91869,
	"./partners-art.svg": 99871,
	"./partners-art_mobile.svg": 46048,
	"./partners-art_pad.svg": 39277,
	"./pending-kyc-icon.svg": 64887,
	"./progress-kyc-icon.svg": 98063,
	"./project_bg.svg": 39981,
	"./project_bg_mobile.svg": 86070,
	"./project_bg_pad.svg": 31999,
	"./project_card_bg.svg": 68400,
	"./project_card_bg_mobile.svg": 60701,
	"./project_card_bg_pad.svg": 35310,
	"./rect_banner.jpeg": 92834,
	"./rect_banner_mobile.jpeg": 31781,
	"./rejected-kyc-icon.svg": 36494,
	"./rocket.png": 21680,
	"./smiles.gif": 44864,
	"./squares-no-borders.svg": 23512,
	"./squares.svg": 41282,
	"./styles/fonts.scss": 38378,
	"./styles/helpers.scss": 26029,
	"./styles/mixins.scss": 60154,
	"./tab-bg-active-first.svg": 4257,
	"./tab-bg-active-second.svg": 20605,
	"./tab-bg.svg": 22717,
	"./top-section-content-bg.svg": 36675,
	"./torch.gif": 54843,
	"./ufo-blurred.svg": 3765,
	"./ufo-light.svg": 44677,
	"./ufo.gif": 85609,
	"./ufo_blurred.png": 62655,
	"./ufo_header.png": 24712,
	"./ufo_home_last.png": 14351,
	"./ufos.svg": 77553,
	"./wallets/cosmos.svg": 40895,
	"./wallets/erc20.svg": 58143,
	"./wallets/kusama.svg": 80605,
	"./wallets/metamask-logo.png": 10948,
	"./wallets/near.svg": 15021,
	"./wallets/polkadot.svg": 91529,
	"./wallets/solana.svg": 70427,
	"./wallets/walletconnect.svg": 74990,
	"./wc2022.jpeg": 91341,
	"./wc2022_mobile.jpeg": 52536,
	"./xmax_banner.jpeg": 47914,
	"./xmax_banner_mobile.jpeg": 4813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;